var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('egreso-form-categoria-select',{attrs:{"categoria":_vm.egreso.categoria,"outlined":true},on:{"process-categoria":_vm.setCategoriaRegister,"clearable":_vm.removeCategoria}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }